module.exports = __webpack_public_path__ + "static/img/logo.a37b2f07.svg";